export const AVAILABLE_LANGUAGES = ['English', 'Spanish']

export class AssessmentFilterOption {
  constructor({ label, value }) {
    this.label = label
    this.value = value || label
  }

  getLabel() {
    return this.label
  }

  getValue() {
    return this.value
  }
}

export class AssessmentSubjectCategoriesMapping {
  constructor({ subjectLabel, subjectValue, categories }) {
    this.subjectOption = new AssessmentFilterOption({
      label: subjectLabel,
      value: subjectValue || subjectLabel
    })
    if (categories && categories.length) {
      this.categoryOptions = categories.map(argCategory => {
        return new AssessmentFilterOption({
          label: argCategory.label,
          value: argCategory.value || argCategory.label
        })
      })
    } else {
      this.categoryOptions = []
    }
  }

  getSubjectLabel() {
    return this.subjectOption.getLabel()
  }

  getSubjectValue() {
    return this.subjectOption.getValue()
  }

  getSubjectOption() {
    return this.subjectOption
  }

  getCategoryOptions() {
    return this.categoryOptions
  }
}

export const assessmentsFilterOptions = {
  mappings: [
    new AssessmentSubjectCategoriesMapping({
      subjectLabel: 'Reading',
      categories: [
        { label: 'Concepts of Print' },
        { label: 'High Frequency Word Reading' },
        { label: 'Phonics & Decoding' },
        { label: 'Phonological Awareness' },
        { label: 'Fluency' },
        { label: 'Comprehension' },
        { label: 'Vocabulary' }
      ]
    }),
    new AssessmentSubjectCategoriesMapping({
      subjectLabel: 'Writing',
      categories: [
        { label: 'Letter Formation' },
        { label: 'Organization of Ideas' },
        { label: 'Conventions & Mechanics' },
        { label: 'Informative & Explanatory' }
      ]
    }),
    new AssessmentSubjectCategoriesMapping({
      subjectLabel: 'Math',
      categories: [
        { label: 'Early Numeracy' },
        { label: 'Number System' },
        { label: 'Number Operations' },
        { label: 'Measurement & Data' },
        { label: 'Geometry' },
        { label: 'Expressions & Equations' },
        { label: 'Ratios & Proportions' },
        { label: 'Statistics & Probability' },
        { label: 'Functions' },
        { label: 'Financial Literacy' }
      ]
    }),
    new AssessmentSubjectCategoriesMapping({
      subjectLabel: 'Science',
      categories: []
    }),
    new AssessmentSubjectCategoriesMapping({
      subjectLabel: 'Social Studies',
      categories: []
    }),
    new AssessmentSubjectCategoriesMapping({
      subjectLabel: 'Behavior & SEL',
      categories: [
        { label: 'Self-Awareness' },
        { label: 'Self-Management' },
        { label: 'Social Awareness' },
        { label: 'Relationship Skills' },
        { label: 'Responsible Decision Making' },
        { label: 'Behavior Data Collection' },
      ]
    }),
    new AssessmentSubjectCategoriesMapping({
      subjectLabel: 'Pre-Academics',
      categories: [
        { label: 'Cognitive Skills' },
        { label: 'Play Skills' },
        { label: 'Motor Skills' },
        { label: 'Emotional Development' },
        { label: 'Early Numeracy' },
        { label: 'Early Literacy' },
        { label: 'Communication & Language' }
      ]
    }),
    new AssessmentSubjectCategoriesMapping({
      subjectLabel: 'Speech & Language',
      categories: [
        { label: 'Fluency' },
        { label: 'Phonological Processes' },
        { label: 'Articulation' },
        { label: 'Receptive Language' },
        { label: 'Expressive Language' },
        { label: 'Pragmatics' },
      ]
    }),
    new AssessmentSubjectCategoriesMapping({
      subjectLabel: 'Transition',
      categories: [
        { label: 'Education & Training' },
        { label: 'Employment' },
        { label: 'Independent Living' },
        { label: 'Self Determination' },
      ]
    }),
    new AssessmentSubjectCategoriesMapping({
      subjectLabel: 'Life Skills',
      categories: [
        { label: 'Community Skills' },
        { label: 'Self-Advocacy' },
        { label: 'Personal Care' },
        { label: 'Household Skills' },
        { label: 'Financial Literacy' },
        { label: 'Transportation & Travel' },
        { label: 'Employment' },
        { label: 'Orientation & Mobility' },
      ]
    }),
    new AssessmentSubjectCategoriesMapping({
      subjectLabel: 'Alt Academics: Reading',
      categories: [
        { label: 'Concepts of Print' },
        { label: 'Phonological Awareness' },
        { label: 'Letter/Sound Identification' },
        { label: 'High Frequency & Functional Word Reading' },
        { label: 'Phonics & Decoding' },
        { label: 'Fluency' },
        { label: 'Comprehension' }
      ]
    }),
    new AssessmentSubjectCategoriesMapping({
      subjectLabel: 'Alt Academics: Writing',
      categories: [
        { label: 'Letter Formation' },
        { label: 'Spelling' },
        { label: 'Capitalization & Punctuation' },
        { label: 'Organization of Ideas' },
        { label: 'Writing Fluency' }
      ]
    }),
    new AssessmentSubjectCategoriesMapping({
      subjectLabel: 'Alt Academics: Math',
      categories: [
        { label: 'Early Numeracy' },
        { label: 'Number Sense & Concepts' },
        { label: 'Calculation & Computation' },
        { label: 'Geometry & Measurement' },
        { label: 'Functional Math' }
      ]
    }),
    new AssessmentSubjectCategoriesMapping({
      subjectLabel: 'Executive Functioning',
      categories: [
        { label: 'Cognitive Flexibility' },
        { label: 'Working Memory' },
        { label: 'Organization & Planning' },
        { label: 'Self-Monitoring' }
      ]
    }),
    new AssessmentSubjectCategoriesMapping({
      subjectLabel: 'Fine Motor',
      categories: [
        { label: 'Fine Motor Precision' },
        { label: 'Functional Fine Motor' },
        { label: 'Handwriting' },
        { label: 'Visual Motor' },
        { label: 'Visual Perception' },
        { label: 'Sensory Integration' },
        { label: 'Keyboarding' }
      ]
    }),
    new AssessmentSubjectCategoriesMapping({
      subjectLabel: 'Gross Motor',
      categories: [
        { label: 'Balance & Coordination' },
        { label: 'Locomotor Skills' },
        { label: 'Strength' },
        { label: 'Functional Mobility' },
        { label: 'Foundational Movement & Transfers' },
        { label: 'Object Control' },
      ]
    }),
    new AssessmentSubjectCategoriesMapping({
      subjectLabel: 'Assistive Technology',
      categories: [
        { label: 'Augmentative & Alternative Communication' },
        { label: 'Access & Operation' },
        { label: 'Daily Routine Integration' },
        { label: 'Self-Advocacy' },
        { label: 'Troubleshooting' },
      ]
    }),
    new AssessmentSubjectCategoriesMapping({
      subjectLabel: 'English Language Development',
      categories: [
        { label: 'Reading' },
        { label: 'Writing' },
        { label: 'Listening' },
        { label: 'Speaking' },
      ]
    })
  ],

  getSubjectOptions() {
    return this.mappings.map(mapping => mapping.getSubjectOption())
  },

  getSubjectOptionFromSubjectLabel(subjectLabel) {
    const foundMapping = this.mappings.find(mapping => {
      return mapping.getSubjectLabel() === subjectLabel
    })
    if (foundMapping) {
      return foundMapping.getSubjectOption()
    }
    return null
  },

  getSubjectValueFromSubjectLabel(subjectLabel) {
    const foundMapping = this.mappings.find(mapping => {
      return mapping.getSubjectLabel() === subjectLabel
    })
    if (foundMapping) {
      return foundMapping.getSubjectValue()
    }
    return null
  },

  getSubjectLabelFromSubjectValue(subjectValue) {
    const foundMapping = this.mappings.find(mapping => {
      return mapping.getSubjectValue() === subjectValue
    })
    if (foundMapping) {
      return foundMapping.getSubjectLabel()
    }
    return null
  },

  getCategoryOptionsFromSubjectValue(subjectValue) {
    const foundSubject = this.mappings.find(mapping => {
      return mapping.getSubjectValue() === subjectValue
    })
    if (foundSubject) {
      return foundSubject.getCategoryOptions()
    }
    return []
  }

}

const GRADE_VALUES = [
  'Birth-3',
  'Pre-K',
  'K',
  '1',
  '2',
  '3',
  '4',
  '5',
  '6',
  '7',
  '8',
  '9',
  '10',
  '11',
  '12',
  'Adult-Transition',
]

export const assessmentGradesSet = GRADE_VALUES.map((value) => ({
  area_uuid: value,
  area_label: value === 'Adult-Transition' ? 'Adult Transition' : value,
}))